<script setup lang="ts">
import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";

import ShareMenu from "./ShareMenu.vue";
</script>

<template>
  <ActionMenuDropdown :action="cardActions.shareLink">
    <ShareMenu />
  </ActionMenuDropdown>
</template>
